import { CognitoAdapterBase } from "../../../services/auth/cognito-adapter-base";
import type { ServiceKey } from "../../../services/auth/types";

/**
 * Engage authenticates against Cognito but emits a non-standard header set:
 *   authorization: <access token>     // bare value, no "Bearer" prefix
 *   id:            <id token>
 *   poolid:        <userPoolId>
 *   region:        <aws region>
 *   x-api-key:     <api key>
 *
 * This is the "engage-multi" header style. All other adapters use Bearer.
 */
export class EngageAuthAdapter extends CognitoAdapterBase {
  readonly key: ServiceKey = "engage";
  readonly category = "engagement";

  getAuthHeaders(): Record<string, string> {
    if (!this.tokens) return {};
    const headers: Record<string, string> = {
      authorization: this.tokens.accessToken,
      id: this.tokens.idToken,
      poolid: this.cfg.poolId,
      region: this.cfg.region,
    };
    if (this.cfg.apiKey) {
      headers["x-api-key"] = this.cfg.apiKey;
    }
    return headers;
  }
}
